import { IAdobeInteraction } from "@abbvie-epi/common/adobe-analytics";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
    constructor(private analyticsHelper: AnalyticsHelperService, private router: Router) {}

    ngOnInit(): void {}

    public track(id: string) {
        const overrides = this.getBaseHeaderAnalyticsOverrides();

        this.analyticsHelper.trackInteraction(id, overrides || undefined);
    }

    private getBaseHeaderAnalyticsOverrides(): IAdobeInteraction {
        return {
            component: {
                
                position: "footer",
                type: "footer"
            },
            content: {
                type: "link"
            },
            interaction: {
                type: "link"
            },
            menu: {
                location: "footer",
                level: "1"
            }
        };
    }
}
